import styled from 'styled-components'
import mediaQuery from './mediaQuery'
import colors from 'styles/colors'

const FormWrap = styled.form`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 100%;
  margin: 0 auto;
  width: 100%;
`

const HalfColumn = styled.div`
  flex: 0 0 50%;
  padding: 0 15px;
  margin-bottom: 5px;
  ${mediaQuery.mobile} {
    flex: 0 0 100%;
    padding: 0;
  }
`

const LongColumn = styled.div`
  flex: 0 0 100%;
  padding: 0 15px;
  margin-bottom: 20px;
  ${mediaQuery.mobile} {
    padding: 0;
  }
`

const ButtonWrap = styled.div`
  flex: 0 0 100%;
  padding: 16px 15px 32px;
  position: relative;

  &:after {
    position: absolute;
    content: '';
    left: -100px;
    right: -100px;
    top: 0;
    height: 1px;
    background-color: #e8ecf3;
  }

  ${mediaQuery.mobile} {
    padding: 20px 0;
  }
`

const InfoText = styled.p`
  font-size: 11px;
  margin-bottom: 5px;
  letter-spacing: 0.03em;
  line-height: 1.25;
  padding: 0 15px;

  ${mediaQuery.mobile} {
    font-size: 10px;
    padding: 0;
  }

  a {
    display: inline;
    margin: 0 5px;
    text-decoration: none;
    &,
    &:hover,
    &:focus {
      color: currentColor;
    }
  }
`

const contactFormTheme = {
  errorColor: colors.textBlack,
  buttonColorMain: colors.main,
  buttonColorSecondary: colors.textBlack,
  dropZoneBorderColor: 'rgba(0, 0, 0, 0.5)',
  dropZoneTitleColor: colors.textBlack,
  dropZoneSubtitleColor: colors.textBlack,
  dropZonePadding: '3px 15px',
}

const sendLinkFormTheme = {
  errorColor: colors.textBlack,
  buttonColorMain: colors.main,
  buttonColorSecondary: colors.textBlack,
  dropZoneBorderColor: 'rgba(0, 0, 0, 0.5)',
  dropZoneTitleColor: colors.textBlack,
  dropZoneSubtitleColor: colors.textBlack,
  dropZonePadding: '3px 15px',
}

export {
  FormWrap,
  ButtonWrap,
  LongColumn,
  HalfColumn,
  contactFormTheme,
  sendLinkFormTheme,
  InfoText,
}
